import Ajax from "ui/helpers/Ajax";
import Alert from "ui/dialogs/alert/Alert";
import {i18n} from "ui/i18n";
import Spinner from "ui/components/spinner/Spinner";
import FatalError from "ui/components/fatal-error/FatalError";
import {validateEmail} from "ui/helpers/validators";

const PATH_REGEXP = /#unsubscribe\/([^\/]+)\/([^\/]+)$/;
const CODE_LENGTH = 32;

export default class ConfirmUnsubscribe {
	/**
	 * @param {string} path
	 * @return {boolean}
	 */
	static isConfirmPath(path) {
		const matches = path.match(PATH_REGEXP);
		if (!matches) {
			return false;
		}

		const token = decodeURIComponent(matches[2]);

		return validateEmail(decodeURIComponent(matches[1])) === ''
			&& token.length === CODE_LENGTH
			&& /^[A-Z0-9]+$/i.test(token);
	}

	/**
	 * @return {Promise<boolean>}
	 */
	async process(path) {
		Spinner.show();
		const {email, code} = this._parsePath(path);

		let res;
		try {
			res = await Ajax.post('/subs/unsubscribe/' + encodeURIComponent(email), {code});

			if (res.result !== 'ok') {
				Spinner.hide();
				await new Alert(res.error, 'error').getResult();
				return false;
			}
		} catch (e) {
			FatalError.show(typeof e === 'string' ? e : i18n('errors.http.error'));
			Spinner.hide();
			return false;
		}

		await new Alert(i18n('messages.confirm-unsub-success', email)).getResult();
	}

	/**
	 * @param {string} path
	 * @return {{code: string, email: string}}
	 * @private
	 */
	_parsePath(path) {
		const matches = path.match(PATH_REGEXP);
		return {
			email: decodeURIComponent(matches[1]),
			code: decodeURIComponent(matches[2]),
		};
	}
}
